module.exports = __webpack_public_path__ + "img/gross-margin-prjweb.c1cd8f0a.png";